export const validatorTypes = {
  notBlank: "notBlank",
  email: "email",
  phoneNumber: "phoneNumber",
  dateOfBirth: "dateOfBirth",
}

export const validators = {
  [validatorTypes.notBlank]: (value) => !!value,
  [validatorTypes.email]: isEmailValid,
  [validatorTypes.phoneNumber]: isPhoneNumberValid,
  [validatorTypes.dateOfBirth]: isDateOfBirthValid,
}

export function isEmailValid(email) {
  return new RegExp(/[\w-]+@([\w-]+\.)+[\w-]+/gim).test(email)
}

export function isPhoneNumberValid(value) {
  const phoneCommonPattern = /^(?:\+|00)?[0-9]{7,17}$/
  const phoneNumber = value.replace(/\s/g, "")
  return phoneCommonPattern.test(phoneNumber) || phoneNumber === ""
}

export function isDateOfBirthValid(value) {
  if (!value) return false
  const dob = new Date(value)
  const today = new Date()
  const age =
    today.getFullYear() -
    dob.getFullYear() -
    (today.getMonth() < dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
      ? 1
      : 0)
  return age >= 18
}
